import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();

  const collections = [
    {
      name: 'الأسئلة والأجوبة',
      path: 'qna',
      route: '/qna',
      icon: 'bi-chat-dots',
      description: 'إدارة أسئلة الشيوخ عبر واتساب',
      color: '#25D366'
    },
    {
      name: 'البث المباشر',
      path: 'lives',
      route: '/live',
      icon: 'bi-broadcast',
      description: 'إدارة البث المباشر',
      color: '#dc3545'
    },
    {
      name: 'الفيديوهات',
      path: 'videos',
      route: '/videos',
      icon: 'bi-camera-video',
      description: 'إدارة محتوى الفيديو',
      color: '#0d6efd'
    },
    {
      name: 'الصوتيات',
      path: 'audios',
      route: '/audios',
      icon: 'bi-mic-fill',
      description: 'إدارة التسجيلات الصوتية',
      color: '#198754'
    },
    {
      name: 'التصنيفات',
      path: 'categories',
      route: '/categories',
      icon: 'bi-folder',
      description: 'إدارة تصنيفات المحاضرات',
      color: '#6f42c1'
    },
    {
      name: 'الوسوم',
      path: 'tags',
      icon: 'bi-tags',
      description: 'إدارة الوسوم',
      color: '#20c997'
    },
    {
      name: 'القراء',
      path: 'readers',
      route: '/readers',
      icon: 'bi-person-circle',
      description: 'إدارة الكتاب والقراء',
      color: '#fd7e14'
    },
    {
      name: 'الوسائط',
      path: 'upload/files',
      icon: 'bi-image',
      description: 'إدارة ملفات الوسائط',
      color: '#0dcaf0'
    },
  ];

  const breadcrumbs = [
    { label: 'الرئيسية', icon: 'bi-house' }
  ];

  return (
    <Layout title="لوحة التحكم" breadcrumbs={breadcrumbs}>
      <Container fluid>
        <div className="mb-4">
          <h3 className="text-muted">مرحباً بعودتك، {user?.username || user?.email}!</h3>
          <p className="text-muted">إدارة محتوى الموسوي تي في من هنا</p>
        </div>

        <Row>
          {collections.map((collection) => (
            <Col md={6} lg={4} className="mb-4" key={collection.path}>
              <Link
                to={collection.route || `/collections/${collection.path}`}
                className="text-decoration-none"
              >
                <Card className="h-100 shadow-sm hover-card border-0">
                  <Card.Body className="d-flex flex-column align-items-center justify-content-center p-4">
                    <div
                      className="icon-wrapper mb-3"
                      style={{
                        width: '80px',
                        height: '80px',
                        backgroundColor: collection.color + '20',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <i
                        className={`${collection.icon}`}
                        style={{
                          fontSize: '2.5rem',
                          color: collection.color
                        }}
                      ></i>
                    </div>
                    <Card.Title className="text-center mb-2 fw-bold" style={{ color: '#212529' }}>
                      {collection.name}
                    </Card.Title>
                    <Card.Text className="text-center text-muted small">
                      {collection.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>

        <style>{`
          .hover-card {
            transition: all 0.3s ease;
          }

          .hover-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15) !important;
          }

          .icon-wrapper {
            transition: all 0.3s ease;
          }

          .hover-card:hover .icon-wrapper {
            transform: scale(1.1);
          }
        `}</style>
      </Container>
    </Layout>
  );
};

export default Dashboard;
